import { useFormContext } from 'react-hook-form';
import { BuyerCard } from 'src/components/Selectors/BuyerSelector/BuyerCard';
import { Content, useContent } from 'src/contexts/ContentContext';
import { Button, Stack, Switch } from 'src/core/ui';
import { Detail } from 'src/modals/common';
import { SectionContent } from 'src/modals/common/Detail/Detail.styled';
import { DetailSection } from 'src/modals/common/DetailSection';
import { useRetailSaleContext } from 'src/modals/RetailSale/RetailSaleLocalContext';
import { useRetailSaleStep } from 'src/modals/RetailSale/RetailSaleLocalContext.atoms';
import { RetailSaleFormValues } from 'src/modals/RetailSale/types';
import { ContentId } from 'src/utils/constants/contentId';

import { RetailSaleEarningsSection } from './RetailSaleCheckoutStep.components';
import { RetailSalePaymentSection } from './RetailSalePaymentSection';

export const RetailSaleCheckoutStep = () => {
  const { selectedBuyer, disabled } = useRetailSaleContext();
  const { goToDetail } = useRetailSaleStep();
  const customerInfoMsg = useContent(ContentId.CustomerInfo);
  const { watch, setValue } = useFormContext<RetailSaleFormValues>();
  const isNoFulfill = watch('isNoFulfill');

  return (
    <Stack direction="column" gap="l">
      {selectedBuyer && (
        <DetailSection
          name={
            <Stack
              direction="row"
              justifyContent="spaceBetween"
              alignItems="center"
              width="full"
            >
              {customerInfoMsg}
              <Button variant="link" size="unset" onClick={goToDetail}>
                <Content id={ContentId.Change} />
              </Button>
            </Stack>
          }
        >
          <SectionContent numOfColumns={1}>
            <BuyerCard buyer={selectedBuyer} />
          </SectionContent>
        </DetailSection>
      )}

      <RetailSaleEarningsSection disabled={disabled} />

      <DetailSection name={<Content id={ContentId.Fulfillment} />}>
        <SectionContent numOfColumns={1}>
          <Detail
            label={<Content id={ContentId.AutoFulfill} />}
            detail={
              // Auto-fulfill is the inverse of no-fulfill (POS-9098): when the switch
              // is off, the created sale is marked no-fulfill.
              <Switch
                checked={!isNoFulfill}
                disabled={disabled}
                onCheckedChange={(isChecked) =>
                  setValue('isNoFulfill', !isChecked, { shouldDirty: true })
                }
              />
            }
          />
        </SectionContent>
      </DetailSection>

      <RetailSalePaymentSection />
    </Stack>
  );
};
